export const DuplicateBankAccountReasons = {
  SHARED_HOUSEHOLD_ACCOUNT: "shared household account",
  SAME_PERSON_MULTIPLE_COMPANIES: "same person in multiple companies",
  SAME_PERSON_EMPLOYEE_AND_CONTRACTOR:
    "same person is both an employee and a contractor",
  OTHER: "other",
} as const;

export type DuplicateBankAccountReason =
  (typeof DuplicateBankAccountReasons)[keyof typeof DuplicateBankAccountReasons];
